import PropTypes from 'prop-types';

const AddressPropType = PropTypes.shape({
  first_name: PropTypes.string,
  last_name: PropTypes.string,
  line_1: PropTypes.string.isRequired,
  line_2: PropTypes.string,
  locality: PropTypes.string.isRequired,
  region: PropTypes.string.isRequired,
  country: PropTypes.string.isRequired,
  postal_code: PropTypes.string.isRequired,
  cross_street: PropTypes.string,
  cross_street_alias: PropTypes.string,
  address_alias: PropTypes.string,
  at_intersection: PropTypes.bool,
  nearby_street: PropTypes.string,
  description: PropTypes.string,
});

export const AddressFormPropType = PropTypes.shape({
  first_name: PropTypes.string,
  last_name: PropTypes.string,
  line_1: PropTypes.string,
  line_2: PropTypes.string,
  locality: PropTypes.string,
  region: PropTypes.string,
  country: PropTypes.string,
  postal_code: PropTypes.string,
  cross_street: PropTypes.string,
  cross_street_alias: PropTypes.string,
  address_alias: PropTypes.string,
  at_intersection: PropTypes.bool,
  nearby_street: PropTypes.string,
  description: PropTypes.string,
});

export default AddressPropType;
